module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento.c06bc731.svg";